import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EXCHANGE_AVAILABILITY_STORE_NAME, ExchangeAvailabilityState } from './exchange-availability.state';

/** Select ExchangeAvailability State */
export const selectExchangeAvailabilityState = createFeatureSelector<ExchangeAvailabilityState>(
  EXCHANGE_AVAILABILITY_STORE_NAME
);

/** Select ExchangeAvailability isPending status */
export const selectExchangeAvailabilityIsPendingStatus = createSelector(
  selectExchangeAvailabilityState,
  (state) => !!state.isPending
);

/** Select ExchangeAvailability isFailure status */
export const selectExchangeAvailabilityIsFailureStatus = createSelector(
  selectExchangeAvailabilityState,
  (state) => !!state.isFailure
);
